import loadable from "@loadable/component";
import { useParams } from "react-router";
import CreateIcon from "../../Icons/CreateIcon";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const EditVehicleTypeComponent = loadable(
  () => import("../../components/VehicleType/EditVehicleType")
);
const EditVehicleType = () => {
  const { id } = useParams();

  const { refetch } = useGetHook({
    queryKey: ["vehicle-type"],
    url: `${APIS.VEHILCE_TYPE}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["vehicle-type"],
    navigateURL: "/vehicle-type",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.VEHILCE_TYPE}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Vehicle Type
        </span>
      </div>
      <EditVehicleTypeComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        refetch={refetch}
      />
    </>
  );
};
export default EditVehicleType;
